import { Outlet, Link } from 'react-router-dom';
import { useAuthStore } from '@/core/stores/authStore';
import { Search, Menu, X } from 'lucide-react';
import { useState } from 'react';

export function PublicLayout() {
  const { isAuthenticated } = useAuthStore();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-cream">
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-warm-gray/10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-sage to-sage-dark rounded-xl flex items-center justify-center text-white">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 3L20 7.5V16.5L12 21L4 16.5V7.5L12 3Z"/>
                  <path d="M12 12L12 21"/>
                  <path d="M12 12L20 7.5"/>
                  <path d="M12 12L4 7.5"/>
                </svg>
              </div>
              <span className="font-display text-xl font-semibold text-navy">
                Bright<span className="text-sage">Path</span>
              </span>
            </Link>

            <nav className="hidden md:flex items-center gap-1">
              <Link to="/resources" className="px-4 py-2 rounded-lg text-navy hover:bg-cream transition-colors font-medium">Resources</Link>
              <Link to="/marketplace" className="px-4 py-2 rounded-lg text-navy hover:bg-cream transition-colors font-medium">Marketplace</Link>
            </nav>

            <div className="flex items-center gap-3">
              {isAuthenticated ? (
                <Link to="/family/dashboard" className="hidden sm:flex items-center gap-2 px-4 py-2 bg-sage text-white rounded-lg hover:bg-sage-dark transition-colors font-medium">
                  Go to Dashboard
                </Link>
              ) : (
                <>
                  <Link to="/login" className="hidden sm:block px-4 py-2 text-navy hover:text-sage transition-colors font-medium">Sign In</Link>
                  <Link to="/register" className="hidden sm:flex items-center gap-2 px-4 py-2 bg-sage text-white rounded-lg hover:bg-sage-dark transition-colors font-medium">Get Started</Link>
                </>
              )}
              <button className="md:hidden p-2 rounded-lg hover:bg-cream transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                {mobileMenuOpen ? <X className="w-6 h-6 text-navy" /> : <Menu className="w-6 h-6 text-navy" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="bg-navy text-white py-12">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between">
            <span className="font-display text-xl font-semibold">Bright<span className="text-sage-light">Path</span></span>
            <p className="text-white/60 text-sm">� 2026 BrightPath. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PublicLayout;

